import { MenuItem } from 'primeng/api';

export const NAV_ITEMS: MenuItem[] = [
  {
    label: 'Actividad Centro',
    routerLink: '/center-activity',
    routerLinkActiveOptions: { exact: true },
  },
  {
    label: 'Histórico + KPIs',
    routerLink: '/kpi-historical',
    routerLinkActiveOptions: { exact: true },
  },
  {
    label: 'Evaluación y Reporting',
    routerLink: '/evaluation-reporting',
    routerLinkActiveOptions: { exact: true },
  },
];

export const ADMIN_NAV_ITEMS: MenuItem[] = [
  {
    label: 'Carreteras',
    routerLink: '/roads',
  },
  {
    label: 'Equipo ITS',
    routerLink: '/kits',
  },
  {
    label: 'Mensajes',
    routerLink: '/messages',
  },
  {
    label: 'Pictogramas',
    routerLink: '/pictograms',
  },
];
